export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/local_seo.6590112.svg";